import { Button, TextInput } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { errorMessage } from "../../shared/session/errors";
import { onboardingHeaders } from "../../shared/session/session";
import { FormError, Page } from "../../shared/ui/Page";

export function RetryVerificationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [f, setF] = useState({ id_number: "", legal_name: "", date_of_birth: "" });
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const body: { id_number?: string; legal_name?: string; date_of_birth?: string } = {};
    if (f.id_number) body.id_number = f.id_number;
    if (f.legal_name) body.legal_name = f.legal_name;
    if (f.date_of_birth) body.date_of_birth = f.date_of_birth;
    const { data, error } = await api.POST("/verification/retry", { headers: onboardingHeaders(), body });
    if (!data) return setError(errorMessage(error, t("error.generic")));
    navigate("/onboarding");
  };
  const set = (k: keyof typeof f) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setF({ ...f, [k]: e.currentTarget.value });
  return (
    <Page title={t("onboarding.retry")}>
      <form onSubmit={submit}>
        <TextInput
          label={t("signup.id_number")}
          inputMode="numeric"
          value={f.id_number}
          onChange={set("id_number")}
          mb="sm"
        />
        <TextInput label={t("signup.legal_name")} value={f.legal_name} onChange={set("legal_name")} mb="sm" />
        <TextInput
          label={t("signup.date_of_birth")}
          type="date"
          value={f.date_of_birth}
          onChange={set("date_of_birth")}
          mb="md"
        />
        <FormError message={error} />
        <Button type="submit" fullWidth mt="sm">
          {t("form.submit")}
        </Button>
      </form>
    </Page>
  );
}
